module.exports = __webpack_public_path__ + "static/media/Danielle Matton Resume.3b356414.pdf";